import React, { useRef, useState, useEffect } from 'react'
import { SegmentRow, ComparisonViewWrap, SegmentSubTitle, TableHeading, ContOuterWrap } from './style'
import NanoDataGridV2 from '../nanoDataGridV2'
import ReportDeepDiveNewWithoutInsights from '../reportDeepDiveNewV2WithoutInsights'
import { getObjectAsArray } from '../../../../util'

const SegmentTable = ({ data = [], hideTopBlueBar = false, type, insightsElementType, showTableGrid, maxValue, isSearchDrivers, props }) => {
  const isSentiments = !['SegmentDriversOnlyAnalysisWithoutSentiments', 'DriversProgressionWithoutSentiments'].includes(insightsElementType)

  return (
    <ComparisonViewWrap className='segmentRowWrap'>

      {showTableGrid === 'graph' && <TableHeading>
        <span>Driver</span>
        <span>{isSentiments ? 'Sentiments' : 'Engagement'}</span>
        {isSentiments && <span>Attributes</span>}
      </TableHeading>}

      {data?.map((item, index) => {
        if (!item?.SegmentDrivers) return false
        const driverElementsWithAttributesArray = Array.isArray(item.SegmentDrivers.DriverElement)
          ? item.SegmentDrivers.DriverElement
          : Object.keys(item.SegmentDrivers.DriverElement || {})?.length
            ? [item.SegmentDrivers.DriverElement]
            : []

        const driverElementsWithAttributes = driverElementsWithAttributesArray.map((d) => {
          if(type === 'SearchKeywords' && insightsElementType === 'SegmentDriversOnlyAnalysisWithoutSentiments3Level') { return d }
          if(type === 'SearchKeywords' && insightsElementType === 'SegmentDriversOnlyAnalysisWithoutSentiments') { return d }

          if(d?.DriverAttributes?.DriverAttributeElement){
            const arr = getObjectAsArray(d.DriverAttributes.DriverAttributeElement).filter(f => f.TargetSegment === d.TargetSegment || f.TargetSegment === '' )
            return {
              ...d,
              DriverAttributes: {
                DriverAttributeElement:arr
              }
            }
          }
          return d
        })

        return (
          <SegmentRow
            sx={{
              marginBottom: data?.length > index ? '10px !important' : '',
            }}
            className='segment-row'
            key={item.SegmentName+'___'+index}
          >
            <SegmentSubTitle className='segment-title'>{item?.SegmentName || item.PeriodName}</SegmentSubTitle>
            <ReportDeepDiveNewWithoutInsights {...props} isSentiments={isSentiments} isSearchKeywords={type} isSearchDrivers={isSearchDrivers} defaultData={driverElementsWithAttributes} />
            
            {/*
            <NanoDataGridV2
              insightsElementType={insightsElementType}
              rows={driverElementsWithAttributes}
              action={<></>}
              theme='theme2'
              setting={{
                DataLength:{},
                ColumnType: '4',
                DriverAttributeStandouts:true,
                DriverAttributes:true,
                DriverRatingImpacts:false,
                DriverRatingImpactsValue:false,
                DriverSubBrandStandouts:false,
                DriverTriggerStandouts:false,
                SearchKeywords:false,
                // SearchKeywords:true,
                ShowTableGrid:showTableGrid,
                Verbatim:true,
                // WithoutSentiments:false,
                WithoutSentiments: ['SegmentDriversOnlyAnalysisWithoutSentiments', 'DriversProgressionWithoutSentiments'].includes(insightsElementType),
                maxValue:maxValue,
              }}
            />
            */}
          </SegmentRow>
        )
      })}
    </ComparisonViewWrap>
  )
}
export default SegmentTable
